import { Record, List } from 'immutable';

export interface AccountNodeProps {
  id: string | null;
  depth: number;
  isLeaf: number;
  displayLabel: string;
  displayOrder: number;
  expandable: boolean;
  svgIconId: string;
  routeTo: string | null;
  account: AccountNodeProps | null;
  children: List<AccountNodeProps> | null;
  allAccountIds: List<string> | null;
  sumCurrentAccountBalances: number;
  sumEndingAccountBalances: number;
  sumOnlineAccountBalances: number;
  sumCPOnlineAccountBalances: number;
  sumCPAvailableAccountBalances: number;
  sumFinalAccountBalances: number;
  sumGoalsAccountBalances: number;
  currency: string | null;
  earliestTransactionDate: string | null;
  hide: boolean;
  type: string;
  clientId?: string;
  name?: string;
}

export type AccountNodes = List<AccountNodeProps>;

export const AccountNode = Record({
  id: null,
  depth: 0,
  isLeaf: 0,
  displayLabel: '',
  displayOrder: 0,
  expandable: true,
  svgIconId: '',
  routeTo: null,
  account: null,
  children: null,
  allAccountIds: null,
  sumCurrentAccountBalances: 0.0,
  sumEndingAccountBalances: 0.0,
  sumOnlineAccountBalances: 0.0,
  sumCPOnlineAccountBalances: 0.0,
  sumCPAvailableAccountBalances: 0.0,
  sumFinalAccountBalances: 0.0,
  sumGoalsAccountBalances: 0.0,
  currency: null,
  earliestTransactionDate: null,
  hide: false,
  type: '',
  clientId: undefined,
  name: undefined,
});

export const accountTypes = {
  banking: 'BANKING',
  investment: 'INVESTMENT',
  liabilities: 'LIABILITIES',
  goals: 'GOALS',
  other: 'OTHER',
  separate: 'SEPARATE',
  hidden: 'HIDDEN',
};
